export const DISPLAY_DATE_FORMAT = 'dd.MM.yyyy'
export const DISPLAY_DATE_INPUT_FORMATS = [DISPLAY_DATE_FORMAT, 'dd.MM.yy'] as const
export const API_DATE_FORMAT = 'yyyy-MM-dd'
